<div class="operation-status-wrapper flex f-c-s">
  <mat-icon color="primary" class="status-true" *ngIf="isTrue">done</mat-icon>
  <mat-icon [color]="falseColor" class="status-false" *ngIf="!isTrue">{{ falseIcon }}</mat-icon>
  <span>{{ label }}</span>
</div>
